import { render, staticRenderFns } from "./CreditDocumentsSummary.vue?vue&type=template&id=4f11e447&"
import script from "./CreditDocumentsSummary.vue?vue&type=script&lang=js&"
export * from "./CreditDocumentsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports